import amapi from '@/api/amapi'

const initialState = () => ({
  notifications: [],
  history: []
})

const state = initialState

const getters = {
  notifications: state => state.notifications,
  notificationsCount: state => state.notifications.length,
  history: state => state.history
}

const mutations = {
  POPULATE_NOTIFICATIONS (state, payload) {
    state.notifications = payload
  },
  POPULATE_HISTORY (state, payload) {
    state.history = payload
  },
  CLEAR_IDLE_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

const actions = {
  async notificationDismiss ({ commit }, id) {
    try {
      return await amapi.makecall('notification_dismiss', { id })
    } catch (e) {
      throw e
    }
  },
  async notificationVisit ({ commit }, id) {
    try {
      const { url } = await amapi.makecall('notification_visit', { id })

      return url
    } catch (e) {
      throw e
    }
  },
  async getHistory ({ commit }) {
    try {
      const { notifications } = await amapi.makecall('notification_history')

      commit('POPULATE_HISTORY', notifications)
    } catch (e) {
      throw e
    }
  },
  async dismissAll () {
    try {
      await amapi.makecall('notification_dismiss_all')
    } catch (e) {
      throw e
    }
  },
  async updateAll ({ dispatch }) {
    try {
      await dispatch('idle/sessionPing', 1, { root: true })
      await dispatch('getHistory')
    } catch (e) {
      throw e
    }
  }
}
const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
